import { createIdentifier } from '@wix/thunderbolt-ioc'
import type { ISsrCacheSiteApi } from './types'

export const SsrCacheSiteSymbol = createIdentifier<ISsrCacheSiteApi>(Symbol('SsrCacheSite'))

export const name = 'ssrCache' as const
export const namespace = 'ssrCache' as const
